import { getBankType } from '@/api/approval'
// 币种列表前端写死
export const coins = [
  {
    id: 1,
    name: '人民币',
    unit: '元',
    tailUnit: '元',
    EnName: 'CNY',
    showApplayReserveFunds: true
  },
  {
    id: 2,
    name: '美元',
    unit: '美元',
    EnName: 'USD',
    tailUnit: '元',
    showApplayReserveFunds: true
  },
  {
    id: 3,
    name: '新币',
    unit: '新币',
    EnName: 'SGD',
    tailUnit: '新加坡元'
  },
  {
    id: 4,
    name: '日元',
    unit: '日元',
    EnName: 'JPY',
    tailUnit: '日元'
  },
  {
    id: 5,
    name: '韩元',
    unit: '韩元',
    EnName: 'KRW',
    tailUnit: '韩元'
  },
  {
    id: 6,
    name: '澳大利亚元',
    unit: '澳大利亚元',
    EnName: 'AUD',
    tailUnit: '澳大利亚元',
    showApplayReserveFunds: true
  },
  {
    id: 7,
    name: '欧元',
    unit: '欧元',
    EnName: 'EUR',
    tailUnit: '欧元',
  },
  {
    id: 8,
    name: '港币',
    unit: '港币',
    EnName: 'HKD',
    tailUnit: '港币',
    tmpShow:true,
    showApplayReserveFunds: true
  },
]
/* 审批流记录/实例类型 */
export const approvalTypes = [
  {
    id: '3',
    name: '已发起'
  },
  {
    id: '1',
    name: '待办'
  },
  {
    id: '2',
    name: '已办'
  },
  {
    id: '4',
    name: '抄送我'
  }
]

/* 审批仙状态 */
export const approvalProjectSatus = [
  {
    id: '0',
    name: '停用'
  },
  {
    id: '1',
    name: '可用'
  }
]


/* 审批实例类型 */
export const approvalInstanceType = [
  {
    id: '1',
    name: '报销',
    enName: 'applayReimbursement'
  },
  {
    id: '2',
    name: '备用金(个人借款)',
    enName: 'applayReserveFunds'
  },
  {
    id: '3',
    name: '用款申请（行政)',
    enName: 'adApplySpendMoney'
  },
  {
    id: '4',
    name: '用款申请（采购）',
    enName: 'pdApplySpendMoney'
  },
  {
    id: '5',
    name: '用款申请（费用）',
    enName: 'costApplySpendMoney'
  },
  {
    id: '6',
    name: '用款申请（固定资产）',
    enName: 'fixedApplySpendMoney'
  },
  {
    id: '7',
    name: '确认费用',
    enName: 'confirmCost'
  },
  {
    id: '8',
    name: '用款申请（保证金）',
    enName: 'earnestApplySpendMoney'
  },
  {
    id: '9',
    name: '客户退款',
    enName: 'clientRefund'
  },
  {
    id: '10',
    name: '应交税金',
    enName: 'taxApplySpendMoney'
  },
  {
    id: '11',
    name: '付款申请（入资款、往来款）',
    enName: 'insideTransferMoney'
  },
]


/**
 * 审批流基本信息：状态
 */
export const approvalStatus = [
  {
    id: '1',
    name: '已启用'
  },
  {
    id: '0',
    name: '已停用'
  }
]

/** 审批实例节点状态 */
export const approvalNodeStatus = [
  {
    id: '0',
    name: '等待',
    enName: 'WAITING',
    class: 'Info',
    elLineIcon: '',
    elLineType: 'Info',
  },
  {
    id: '1',
    name: '审批中',
    class: '',
    enName: 'PENDING',
    elLineIcon: 'el-icon-more-outline',
    elLineType: 'success'
  },
  {
    id: '2',
    name: '已通过',
    class: 'success',
    enName: 'APPROVED',
    icon: '',
    elLineIcon: 'el-icon-check',
    elLineType: 'primary'
  },
  {
    id: '3',
    name: '已拒绝',
    class: 'warning',
    enName: 'REJECTED',
    elLineIcon: 'el-icon-close',
    elLineType: 'danger'
  },
  {
    id: '4',
    name: '已取消',
    class: 'warning',
    enName: 'CANCELED',
    elLineIcon: 'el-icon-close',
    elLineType: 'danger'
  },
  {
    id: '5',
    name: '已完成',
    enName: 'DONE',
    class: 'Info',
    elLineIcon: '',
    elLineType: 'Info'
  }
]
export const statusList = [
  {
    name: '全部',
    status: ''
  },
  {
    name: '审批中',
    status: 1
  },
  {
    name: '已同意',
    status: 2
  },
  {
    name: '已拒绝',
    status: 3
  },
  {
    name: '撤回',
    status: 4
  },
  {
    name: '删除',
    status: 5
  },
]

/** 审批实例任务状态 */
export const approvalTaskStatus = [
  {
    id: '0',
    name: '',
    class: '',
    enName: 'PENDING',
    elLineIcon: 'el-icon-more-outline',
    elLineType: 'success'
  },
  {
    id: '1',
    name: '审批中',
    class: '',
    enName: 'PENDING',
    elLineIcon: 'el-icon-more-outline',
    elLineType: 'success'
  },
  {
    id: '2',
    name: '已通过',
    class: 'success',
    enName: 'APPROVED',
    icon: '',
    elLineIcon: 'el-icon-check',
    elLineType: 'primary'
  },
  {
    id: '3',
    name: '已拒绝',
    class: 'warning',
    enName: 'REJECTED',
    elLineIcon: 'el-icon-close',
    elLineType: 'danger'
  },
  {
    id: '4',
    name: '已撤回',
    class: 'warning',
    enName: 'CANCELED',
    elLineIcon: 'el-icon-close',
    elLineType: 'danger'
  },
  {
    id: '5',
    name: '已删除',
    enName: 'DELETED',
    class: 'danger',
    elLineIcon: 'el-icon-folder-remove',
    elLineType: 'danger'
  },
  {
    id: '6',
    name: '转交',
    class: 'success',
    enName: 'TRANSFER',
    elLineIcon: 'el-icon-check',
    elLineType: 'primary'
  },
]

/** 审批实例状态 */
export const approvalInstanceStatus = [
  {
    id: '1',
    name: '审批中',
    class: '',
    enName: 'PENDING',
    elLineIcon: 'el-icon-more-outline',
    elLineType: 'success'
  },
  {
    id: '2',
    name: '已同意',
    class: 'success',
    enName: 'APPROVED',
    icon: '',
    elLineIcon: 'el-icon-check',
    elLineType: 'primary'
  },
  {
    id: '3',
    name: '已拒绝',
    class: 'danger',
    enName: 'REJECTED',
    elLineIcon: 'el-icon-close',
    elLineType: 'danger'
  },
  {
    id: '4',
    name: '已撤回',
    class: 'danger',
    enName: 'CANCELED',
    elLineIcon: 'el-icon-close',
    elLineType: 'danger'
  },
  {
    id: '5',
    name: '已删除',
    enName: 'DELETED',
    class: 'danger',
    elLineIcon: 'el-icon-folder-remove',
    elLineType: 'danger'
  }
]

/**
 * 审批流基本信息：状态
 */
export const approvalNodeTypes = [
  {
    id: '0',
    name: '结束',
    enName: 'end'
  },
  {
    id: '1',
    name: '发起',
    enName: 'start'
  },
  {
    id: '2',
    name: '审批'
  },
  {
    id: '3',
    name: '抄送'
  }
]

/**
 * 企业类型
 */
export const companyTypes = [
  {
    id: 1,
    name: '我方公司',
    enName: 'slef',
    allowCreate: false,
    showOption: false
  },
  {
    id: 2,
    name: '供应商',
    enName: 'provider',
    allowCreate: true,
    showOption: true
  },
  {
    id: 3,
    name: '客户',
    enName: 'client',
    allowCreate: true,
    showOption: true
  }
]

export const companyStatus = [
  {
    id: 1,
    name: '审核中',
    type: '',
  },
  {
    id: 2,
    name: '已通过',
    type: 'success'
  },
  {
    id: 3,
    name: '已拒绝',
    type: 'danger'
  }
]

export const attachFormConfig = [
  {
    formType: 'select',
    field: 'bussiness_type',
    title: '费用类型',
    checked: false,
    required: true,
    disabled: false,
    value: '',
    placeholder: '请选择费用类型',
    options: [],
    async opetionGenerator() {
      return Promise.resolve([
        { value: '单位往来', label: '单位往来' },
        { value: '应付账款', label: '应付账款' },
        { value: '长期股权投资', label: '长期股权投资' },
        { value: '其他应收款', label: '其他应收款' },
      ])
    }
  },
  {
    formType: 'select',
    field: 'tax_type',
    title: '税金类型',
    checked: false,
    required: true,
    disabled: false,
    value: '',
    placeholder: '请选择税金类型',
    options: [],
    async opetionGenerator() {
      return Promise.resolve([
        { value: '印花税', label: '印花税' },
        { value: '所得税', label: '所得税' },
    
      ])
    }
  },
  {
    formType: 'select',
    field: 'bank_type',
    title: '银行类型',
    checked: false,
    required: true,
    disabled: false,
    value: '',
    placeholder: '请选择银行类型',
    options: [],
    async opetionGenerator() {
      try {
        let res = await getBankType();
        if (res.code == 0) {
          return res.data;
        } else {
          return []
        }
      } catch (err) {
        console.log(err);
      }
      // return Promise.resolve([
      //   { value: '上海浦东发展银行人民币户', label: '上海浦东发展银行人民币户' },
      //   { value: '上海浦东发展银行人民币待支付账户', label: '上海浦东发展银行人民币待支付账户' },
      //   { value: '宁波银行待支付账户', label: '宁波银行待支付账户' },
      //   { value: '宁波银行人民币户', label: '宁波银行人民币户' },
      //   { value: '宁波银行美元户', label: '宁波银行美元户' },
      //   { value: '上海浦东发展银行美元户', label: '上海浦东发展银行美元户' },
      //   { value: '招商银行人民币户', label: '招商银行人民币户' },
      //   { value: '招商银行待支付户', label: '招商银行待支付户' },
      //   { value: '招商银行美元户', label: '招商银行美元户' },
      //   { value: '上海浦东发展银行北京长安街支行', label: '上海浦东发展银行北京长安街支行' },
      //   { value: '华侨银行美元户', label: '华侨银行美元户' },
      //   { value: '华侨银行新币户', label: '华侨银行新币户' },
      //   { value: '香港账户', label: '香港账户' },
      //   { value: '华侨银行定期存款', label: '华侨银行定期存款' }
      // ])
    }
  },
  {
    formType: 'datetime',
    field: 'bank_pay_time',
    title: '银行付款时间',
    checked: false,
    placeholder: '请选择银行付款时间',
    required: true,
    disabled: false,
    value: ''
  },
  {
    formType: 'select',
    field: 'coin_type',
    title: '付款币种',
    checked: false,
    placeholder: '请选择付款币种',
    required: true,
    disabled: false,
    value: '',
    options: [],
    async opetionGenerator() {
      return Promise.resolve([
        { value: '人民币CNY', label: '人民币CNY' },
        { value: '美元USD', label: '美元USD' },
        { value: '新币SGD', label: '新币SGD' },
        { value: '港币HKD', label: '港币HKD' }
      ])
    }
  },
  {
    formType: 'number',
    field: 'money',
    title: '付款金额',
    checked: false,
    placeholder: '请输入金额',
    required: true,
    disabled: false,
    value: '',
  },
  {
    formType: 'number',
    field: 'exchange_rate',
    title: '银行汇率',
    checked: false,
    placeholder: '请输入银行汇率',
    required: true,
    disabled: false,
    value: '',
  },
  {
    formType: 'upload',
    field: 'img_keys',
    title: '付款凭证',
    checked: false,
    placeholder: '请上传付款凭证',
    required: true,
    disabled: false,
    value: [],
  }
]

setMapByArray(coins)
setMapByArray(approvalTypes)
setMapByArray(approvalProjectSatus)
setMapByArray(approvalInstanceType)
setMapByArray(approvalStatus)
setMapByArray(approvalNodeStatus)
setMapByArray(approvalTaskStatus)
setMapByArray(approvalInstanceStatus)
setMapByArray(approvalNodeTypes)
setMapByArray(companyTypes)
setMapByArray(companyStatus)
setMapByArray(attachFormConfig, 'field', 'title')

/**
 * 给Array设置Map
 * 默认提取ID和Name
 */
export function setMapByArray(datas, idLebal = 'id', textLabel = 'name') {
  if (!Array.isArray(datas)) return datas
  datas.constMap = {}
  datas.constMap.idMap = {}
  datas.constMap.nameMap = {}
  for (const item of datas) {
    datas.constMap.idMap[`${item[idLebal]}`] = item
    datas.constMap.nameMap[`${item[textLabel]}`] = item
  }
  return datas
}
